// extracted by mini-css-extract-plugin
export default {"importCsvCard":"AddSup_importCsvCard__mBSpl","addSupplierBtnContainer":"AddSup_addSupplierBtnContainer__HFEc8"};